module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "level"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/forward#forward"
    }
  }, [_vm._v("Foreword by David Lehman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction by Denise Duhamel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Kim Addonizio,")]), _vm._v(" “Divine”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sherman Alexie,")]), _vm._v(" “Pachyderm”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Nathan Anderson,")]), _vm._v(" “Stupid Sandwich”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Nin Andrews,")]), _vm._v(" “The Art of Drinking Tea”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("John Ashbery,")]), _vm._v(" “Resisting Arrest”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Wendy Barker,")]), _vm._v(" “Books, Bath Towels, and Beyond”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Jan Beatty,")]), _vm._v(" “Youngest Known Savior”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Bruce Bond,")]), _vm._v(" “The Unfinished Slave”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Traci Brimhall,")]), _vm._v(" “Dear Thanatos,”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Jericho Brown,")]), _vm._v(" “Hustle”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Andrei Codrescu,")]), _vm._v(" “Five One-Minute Eggs”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Billy Collins,")]), _vm._v(" “Foundling”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Martha Collins,")]), _vm._v(" “[white paper 24]”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Kwame Dawes,")]), _vm._v(" “Death”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Connie Deanovich,")]), _vm._v(" “Divestiture”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Timothy Donnelly,")]), _vm._v(" “Apologies from the Ground Up”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Stephen Dunn,")]), _vm._v(" “The Statue of Responsibility”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Daisy Fried,")]), _vm._v(" “This Need Not Be a Comment on Death”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Amy Gerstler,")]), _vm._v(" “Womanishness”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Louise Glück,")]), _vm._v(" “Afterword”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Beckian Fritz Goldberg,")]), _vm._v(" “Henry’s Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Terrance Hayes,")]), _vm._v(" “New Jersey Poem”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Rebecca Hazelton,")]), _vm._v(" “Book of Forget”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Elizabeth Hazen,")]), _vm._v(" “Thanatosis”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("John Hennessy,")]), _vm._v(" “Green Man, Blue Pill”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("David Hernandez,")]), _vm._v(" “All-American”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tony Hoagland,")]), _vm._v(" “Wrong Question”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Anna Maria Hong,")]), _vm._v(" “A Parable”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Major Jackson,")]), _vm._v(" “Why I Write Poetry”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Mark Jarman,")]), _vm._v(" “George W. Bush”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Lauren Jensen,")]), _vm._v(" “it’s hard as so much is”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A. Van Jordan,")]), _vm._v(" “Blazing Saddles”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Lawrence Joseph,")]), _vm._v(" “Syria”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Anna Journey,")]), _vm._v(" “Wedding Night: We Share an Heirloom Tomato on Our Hotel Balcony Overlooking the Ocean in Which Natalie Wood Drowned”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Laura Kasischke,")]), _vm._v(" “Perspective”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Victoria Kelly,")]), _vm._v(" “When the Men Go Off to War”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("David Kirby,")]), _vm._v(" “Pink Is the Navy Blue of India”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Noelle Kocot,")]), _vm._v(" “Aphids”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("John Koethe,")]), _vm._v(" “Eggheads”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Dorothea Lasky,")]), _vm._v(" “Poem for Anne Sexting”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Dorianne Laux,")]), _vm._v(" “Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Amy Lemmon,")]), _vm._v(" “I take your T-shirt to bed again . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Thomas Lux,")]), _vm._v(" “Outline for My Memoir”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Anthony Madrid,")]), _vm._v(" “Once upon a Time”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sally Wen Mao,")]), _vm._v(" “XX”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Jen McClanaghan,")]), _vm._v(" “My Lie”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Campbell McGrath,")]), _vm._v(" “January 17”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Jesse Millner,")]), _vm._v(" “In Praise of Small Gods”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("D. Nurkse,")]), _vm._v(" “Psalm to Be Read with Closed Eyes”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Ed Ochester,")]), _vm._v(" “New Year”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Paisley Rekdal,")]), _vm._v(" “Birthday Poem”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Adrienne Rich,")]), _vm._v(" “Endpapers”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Anne Marie Rooney,")]), _vm._v(" “Lake Sonnet”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("J. Allyn Rosser,")]), _vm._v(" “Intro to Happiness”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Mary Ruefle,")]), _vm._v(" “Little Golf Pencil”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Maureen Seaton,")]), _vm._v(" “Chelsea/Suicide”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tim Seibles,")]), _vm._v(" “Sotto Voce: Othello, Unplugged”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Vijay Seshadri,")]), _vm._v(" “Trailing Clouds of Glory”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Peter Jay Shippy,")]), _vm._v(" “Western Civilization”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Mitch Sisskind,")]), _vm._v(" “Joe Adamczyk”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Aaron Smith,")]), _vm._v(" “What It Feels Like to Be Aaron Smith”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Stephanie Strickland,")]), _vm._v(" “Introductions”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Adrienne Su,")]), _vm._v(" “On Writing”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("James Tate,")]), _vm._v(" “The Baby”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Emma Trelles,")]), _vm._v(" “Florida Poem”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("David Trinidad,")]), _vm._v(" “from "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Peyton Place: A Haiku Soap Opera,")]), _vm._v(" Season Two, 1965–1966”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Jean Valentine,")]), _vm._v(" “1945”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Paul Violi,")]), _vm._v(" “Now I’ll Never Be Able to Finish That Poem to Bob”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("David Wagoner,")]), _vm._v(" “Casting Aspersions”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Stacey Waite,")]), _vm._v(" “The Kind of Man I Am at the DMV”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Richard Wilbur,")]), _vm._v(" “Sugar Maples, January”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Angela Veronica Wong and Amy Lawless,")]), _vm._v(" “It Can Feel Amazing to Be Targeted by a Narcissist”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Wendy Xu,")]), _vm._v(" “Where the Hero Speaks to Others”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Kevin Young,")]), _vm._v(" “Wintering”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Matthew Zapruder,")]), _vm._v(" “Albert Einstein”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors#contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors’ Notes and Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/magazines#magazines",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magazines Where the Poems Were First Published")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowldgments#acknowldgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0